export class ProjectRegistryError extends Error {
    constructor(message, code = "unauthorized") {
        super(message);
        this.code = code;
        this.name = "ProjectRegistryError";
    }
}
//# sourceMappingURL=types.js.map